module.exports = __webpack_public_path__ + "img/Gruselgefahr.4f7974e3.jpg";